
import React, { useEffect, useRef } from 'react';
import { FiTrash2, FiMaximize2, FiCheckCircle, FiCopy, FiZap, FiPlus, FiExternalLink, FiCornerDownRight, FiRepeat } from 'react-icons/fi';
import ReactDOM from 'react-dom';

const TaskContextMenu = ({ position, onClose, onAction, task }) => {
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                onClose();
            }
        };

        const handleContextMenuOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                onClose();
            }
        };

        const handleEscape = (e) => {
            if (e.key === 'Escape') onClose();
        };

        // Delay adding listeners to prevent immediate close from the triggering event
        const timer = setTimeout(() => {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('contextmenu', handleContextMenuOutside);
            document.addEventListener('keydown', handleEscape);
            document.addEventListener('scroll', onClose, true);
        }, 50);

        return () => {
            clearTimeout(timer);
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('contextmenu', handleContextMenuOutside);
            document.removeEventListener('keydown', handleEscape);
            document.removeEventListener('scroll', onClose, true);
        };
    }, [onClose]);

    // Adjust position to stay in viewport
    const style = {
        top: Math.min(position.y, window.innerHeight - 420),
        left: Math.min(position.x, window.innerWidth - 260),
    };

    const handleAction = (action) => {
        onAction(action, task);
        onClose();
    };

    return ReactDOM.createPortal(
        <div
            ref={menuRef}
            className="fixed z-[99999] bg-white rounded-xl shadow-2xl border border-gray-100 py-2 w-[240px] text-[13px] font-medium text-gray-700 animate-in fade-in zoom-in-95 duration-100 font-sans"
            style={style}
            onClick={(e) => e.stopPropagation()}
            onContextMenu={(e) => e.preventDefault()}
        >
            <div className="px-4 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wider border-b border-gray-100 mb-1 truncate select-none">
                {task.titulo}
            </div>

            <button onClick={() => handleAction('duplicate')} className="w-full text-left px-4 py-2 hover:bg-gray-50 flex items-center gap-3 transition-colors">
                <FiCopy className="text-gray-500" size={15} />
                Duplicar tarea
            </button>
            <button onClick={() => handleAction('follow_up')} className="w-full text-left px-4 py-2 hover:bg-gray-50 flex items-center gap-3 transition-colors">
                <FiRepeat className="text-gray-500" size={15} />
                Crear tarea de seguimiento
            </button>
            <button onClick={() => handleAction('toggle_status')} className="w-full text-left px-4 py-2 hover:bg-gray-50 flex items-center gap-3 transition-colors">
                <FiCheckCircle className={task.estado === 'finalizado' ? 'text-green-500' : 'text-gray-500'} size={15} />
                {task.estado === 'finalizado' ? 'Marcar como pendiente' : 'Marcar como finalizada'}
            </button>
            <button onClick={() => handleAction('add_subtask')} className="w-full text-left px-4 py-2 hover:bg-gray-50 flex items-center gap-3 transition-colors">
                <FiCornerDownRight className="text-gray-500" size={15} />
                Agregar subtarea
            </button>

            <div className="my-1 border-t border-gray-100" />

            <button onClick={() => handleAction('open')} className="w-full text-left px-4 py-2 hover:bg-gray-50 flex items-center gap-3 transition-colors">
                <FiMaximize2 className="text-gray-500" size={15} />
                Abrir detalles
            </button>
            <button onClick={() => handleAction('open_new_tab')} className="w-full text-left px-4 py-2 hover:bg-gray-50 flex items-center gap-3 transition-colors">
                <FiExternalLink className="text-gray-500" size={15} />
                Abrir en pestaña nueva
            </button>
            <button onClick={() => handleAction('copy_link')} className="w-full text-left px-4 py-2 hover:bg-gray-50 flex items-center gap-3 transition-colors">
                <FiCopy className="text-gray-500" size={15} />
                Copiar enlace
            </button>

            <div className="my-1 border-t border-gray-100" />

            <button onClick={() => handleAction('ai')} className="w-full text-left px-4 py-2 hover:bg-gray-50 flex items-center gap-3 transition-colors">
                <FiZap className="text-indigo-500" size={15} />
                Mejorar con IA
            </button>

            <div className="my-1 border-t border-gray-100" />

            <button onClick={() => handleAction('delete')} className="w-full text-left px-4 py-2 hover:bg-red-50 text-red-600 flex items-center gap-3 group transition-colors">
                <FiTrash2 className="text-red-400 group-hover:text-red-600" size={15} />
                Eliminar tarea
            </button>
        </div>,
        document.body
    );
};

export default TaskContextMenu;
